import React, {useState,useEffect} from 'react';
import {Formulario, Input, Etiqueta, ContenedorBoton} from '../elementos/ElementosDeFormulario'
import Boton from '../elementos/Boton'
import Api from '../servicios/api';
import Alerta from '../elementos/Alerta'
import {useAuth} from "./../contextos/AuthContext";
import { useNavigate } from "react-router-dom";

const FormularioVisita = ({visita}) => {
    let date = new Date();
    const {idUsuario} = useAuth();
    const [inputNombres, setInputNombres] = useState('');
    const [inputCargo, setInputCargo] = useState('');
    const [inputCorreo, setInputCorreo] = useState('');
    const [inputTelefono, setInputTelefono] = useState('');
    const [inputOpinion, setInputOpinion] = useState('');
    const [inputFecha, setInputFecha] = useState('');
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const navigate = useNavigate();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        if(visita){
            setInputNombres(visita.Vis_Nombres)
            setInputCargo(visita.Vis_Cargo)
            setInputCorreo(visita.Vis_Correo)
            setInputTelefono(visita.Vis_Telefono)
            setInputOpinion(visita.Vis_Opinion)
            setInputFecha(visita.Vis_Fecha)
        }
        else{
            setInputFecha(date.getFullYear() + "-" + ('0' + (date.getMonth()+1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2));
        }
    }, [visita]);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'nombres':
                setInputNombres(e.target.value);
                break;
            case 'cargo':
                setInputCargo(e.target.value);
                break;
            case 'telefono':
                setInputTelefono(e.target.value);
                break;
            case 'correo':
                setInputCorreo(e.target.value);
                break;
            case 'opinion':
                setInputOpinion(e.target.value);
                break;
            case 'fecha':
                setInputFecha(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        // Validaciones del lado del cliente para que los inputs no esten vacios
        if(inputNombres === '' || inputCargo === '' || inputOpinion === '' || inputFecha === ''){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        var datosEnviar;
        if(!visita){
            datosEnviar = {nombres:inputNombres, cargo:inputCargo, telefono:inputTelefono, correo:inputCorreo, opinion:inputOpinion, fecha:inputFecha, idUser:idUsuario}

            fetch(Api+"?insertarVisitaDirecta=1",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                if(datosRespuesta.success === 1){
                    setInputNombres('');
                    setInputCargo('');
                    setInputCorreo('');
                    setInputTelefono('');
                    setInputOpinion('');
                    setInputFecha('');
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'exito',
                        mensaje: 'Visita registrada correctamente.'
                    });
                }
                else{
                    setEstadoAlerta(true);
                    setAlerta({
                        tipo: 'error',
                        mensaje: 'Error al registrar visita.'
                    });
                }
            })
            .catch(console.log)
        }

        else{
            datosEnviar = {id:visita.Vis_ID, nombres:inputNombres, cargo:inputCargo, telefono:inputTelefono, correo:inputCorreo, opinion:inputOpinion, fecha:inputFecha, idUser:idUsuario}

            fetch(Api+"?actualizarVisitaDirecta=1",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                navigate("/gestion-visitas-directas");
            })
            .catch(console.log)
        }
    }

    return (
        <>
            <Formulario onSubmit={handleSubmit}>
                <div>
                    <Etiqueta htmlFor="">Nombres y Apellidos</Etiqueta>
                    <Input
                        type="text"
                        name="nombres"
                        placeholder="Ingrese Nombres y Apellidos"
                        value={inputNombres}
                        onChange={handleChange}
                    />

                    <Etiqueta htmlFor="">Cargo o Función</Etiqueta>
                    <Input
                        type="text"
                        name="cargo"
                        placeholder="Ingrese Cargo"
                        value={inputCargo}
                        onChange={handleChange}
                    />

                    <Etiqueta htmlFor="">Telefono</Etiqueta>
                    <Input
                        type="text"
                        name="telefono"
                        placeholder="Ingrese teléfono"
                        value={inputTelefono}
                        onChange={handleChange}
                    />

                    <Etiqueta htmlFor="">Correo electrónico</Etiqueta>
                    <Input
                        type="email"
                        name="correo"
                        placeholder="Correo electrónico"
                        value={inputCorreo}
                        onChange={handleChange}
                    />

                    <Etiqueta htmlFor="">Opinión</Etiqueta>
                    <Input
                        type="text"
                        name="opinion"
                        placeholder="Opinión"
                        value={inputOpinion}
                        onChange={handleChange}
                    />

                    <Etiqueta htmlFor="">Fecha de Visita</Etiqueta>
                    <Input
                        type="date"
                        name="fecha"
                        placeholder="Opinión"
                        value={inputFecha}
                        onChange={handleChange}
                    />
                </div>

                <ContenedorBoton>
                        <Boton to="/consultar-visitas-directas">Cancelar</Boton>
                        <Boton as="button" type="submit" primario="true">
                            {visita ? 'Actualizar' : 'Guardar'} 
                        </Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}
 
export default FormularioVisita;